import { useRef } from 'react';
import { Scrollbar, Mousewheel, FreeMode } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Swiper as SwiperClass } from 'swiper/types';
import { useTranslation } from 'next-i18next';
import styles from '@features/showrooms/sections/ShowroomsSection/Components/ShowroomFiltersInfo/ShowroomFiltersInfo.styles';
import Heading from '@components/Heading/Heading';
import 'swiper/css';
import 'swiper/css/free-mode';
import 'swiper/css/scrollbar';
const ShowroomFiltersInfo = () => {
  const {
    t
  } = useTranslation('common');
  const swiperInstance = useRef<SwiperClass>(null);
  return <div sx={styles.container}>
      <Heading h={2} size={24} uppercase pb={24} mobile>
        {t('shoowroomMapFilters.filtersShoowrooms')}
      </Heading>
      <Swiper direction="vertical" modules={[Scrollbar, Mousewheel, FreeMode]} scrollbar={{
      draggable: true,
      hide: false,
      dragSize: 80
    }} onSwiper={swiper => {
      swiperInstance.current = swiper;
    }} followFinger slidesPerView="auto" freeMode mousewheel>
        <SwiperSlide>
          <div sx={styles.item}>
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.interiors')}
            </Heading>
            <span>{t('shoowroomMapFilters.interiorsDescription')}</span>
          </div>
          <div sx={styles.item}>
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.furnitureTitle')}
            </Heading>
            <span>{t('shoowroomMapFilters.furnitureDescription')}</span>
          </div>
          <div sx={styles.item}>
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.dipTitle')}
            </Heading>
            <span>{t('shoowroomMapFilters.dipDescription')}</span>
          </div>
          <div sx={styles.item}>
            <Heading h={1} size={18} uppercase pb={8} mobile>
              {t('shoowroomMapFilters.voxboxTitle')}
            </Heading>
            <span>{t('shoowroomMapFilters.voxboxDescription')}</span>
          </div>
        </SwiperSlide>
      </Swiper>
    </div>;
};
export default ShowroomFiltersInfo;